import React from "react";
import { InviteDetails } from "../../components";

export default function Invite() {
  return (
    <div>
      <>
        <InviteDetails />
      </>
    </div>
  );
}
